
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const HANDLE = 'shipping-protection';
  const OPT_OUT = 'sp_optout';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const safe = (fn) => { try { return fn(); } catch (e) { return null; } };
  const local = { get: (k) => safe(() => localStorage.getItem(k)), set: (k, v) => safe(() => localStorage.setItem(k, v)), del: (k) => safe(() => localStorage.removeItem(k)) };
  let fetchedId = null;
  async function variantId() {
    const el = document.querySelector('[data-sp-variant]');
    if (el) return Number(el.dataset.spVariant);
    if (fetchedId === null) {
      try {
        const p = await (await fetch(`${root}products/${HANDLE}.js`, { headers: { Accept: 'application/json' } })).json();
        const v = (p.variants || []).find((x) => x.available);
        fetchedId = v ? v.id : 0;
      } catch (e) { fetchedId = 0; }
    }
    return fetchedId || null;
  }
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const refresh = () => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  let busy = false;
  let addFailed = false;

  function showState(inCart) {
    document.querySelectorAll('[data-sp-toggle]').forEach((input) => { input.checked = inCart || !local.get(OPT_OUT); });
  }

  async function setQuantity(id, quantity) {
    if (busy) return;
    busy = true;
    try {
      const res = quantity > 0
        ? await fetch(`${root}cart/add.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id, quantity }] }) })
        : await fetch(`${root}cart/change.js`, { method: 'POST', headers: json, body: JSON.stringify({ id: String(id), quantity: 0 }) });
      if (!res.ok) {
        if (quantity > 0) addFailed = true;
        console.warn('[shipping-protection] cart update failed', res.status);
      }
    } catch (e) {
      if (quantity > 0) addFailed = true;
      console.warn('[shipping-protection] cart update failed', e);
    } finally {
      busy = false;
      refresh();
    }
  }

  async function reconcile() {
    const id = await variantId();
    if (!id || busy) return;
    let cart;
    try { cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
    const protection = cart.items.filter((i) => i.handle === HANDLE);
    const goods = cart.items.filter((i) => i.handle !== HANDLE);
    if (!goods.length && protection.length) return setQuantity(id, 0);
    if (protection.length && protection.reduce((n, i) => n + i.quantity, 0) > 1) {
      busy = true;
      try { await fetch(`${root}cart/change.js`, { method: 'POST', headers: json, body: JSON.stringify({ id: protection[0].key, quantity: 1 }) }); } catch (e) {  }
      busy = false;
      return refresh();
    }
    if (goods.length && !protection.length && !local.get(OPT_OUT) && !addFailed) return setQuantity(id, 1);
    showState(protection.length > 0);
  }

  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-sp-toggle]')) return;
    const id = await variantId();
    if (!id) return;
    if (input.checked) { local.del(OPT_OUT); addFailed = false; } else local.set(OPT_OUT, '1');
    setQuantity(id, input.checked ? 1 : 0);
  });
  document.addEventListener('on:cart:add', reconcile);
  document.addEventListener('on:cart:after-merge', reconcile);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
